import { formatDownloadCenterDate, formatDownloadCenterFileSize } from '../../../utils/helpers/downloadCenterHelpers';
import ReportPageShell from '../../../components/layouts/ReportPageShell';
import useDownloadCenter from '../../../hooks/download/useDownloadCenter';
import './downloadcenter.css';
import React from 'react';

const DownloadCenter = () => {
  const { activeFolder, folders, handleDownload, handleFileSelect, handleFolderSelect, handleNextPage,
    handlePreviousPage, hasNextPage, hasPreviousPage, isLoadingFiles, isDownloading, selectedCount,
    selectedFileNames, visibleFiles,
  } = useDownloadCenter();

  return (
    <ReportPageShell>
      <div className="downloadCenterShell">
        <div className="downloadCenterHeader">
          <span>Download Center</span>
        </div>

        <div className="downloadCenterLayout">
          <aside className="downloadCenterSidebar" aria-label="File types">
            <div className="downloadCenterSidebarTitle">FILE TYPES</div>

            {folders.map((folder) => (
              <button
                className={`downloadCenterCategory ${folder.name === activeFolder ? 'active' : ''}`}
                disabled={isLoadingFiles}
                key={folder.name}
                onClick={() => handleFolderSelect(folder.name)}
                title={folder.name}
                type="button"
              >
                <span>{folder.name}</span>
                <span>{folder.countLabel ?? folder.count}</span>
              </button>
            ))}
          </aside>

          <section className="downloadCenterContent" aria-label="Download files">
            <div className="downloadCenterContentHeader">
              <div>
                <h2>{activeFolder || 'Files'}</h2>
                <p>{isLoadingFiles ? 'Loading files...' : `${visibleFiles.length} files shown`}</p>
              </div>
              <div className="downloadCenterActions">
                {hasPreviousPage && (
                  <button
                    className="downloadCenterNextButton"
                    disabled={isLoadingFiles}
                    onClick={handlePreviousPage}
                    type="button"
                  >
                    Previous
                  </button>
                )}
                {hasNextPage && (
                  <button
                    className="downloadCenterNextButton"
                    disabled={isLoadingFiles}
                    onClick={handleNextPage}
                    type="button"
                  >
                    Next
                  </button>
                )}
                <button
                  className="downloadCenterDownloadButton"
                  disabled={selectedCount === 0 || isDownloading || isLoadingFiles}
                  onClick={handleDownload}
                  type="button"
                >
                  {isDownloading ? 'Downloading...' : `Download${selectedCount > 0 ? ` (${selectedCount})` : ''}`}
                </button>
              </div>
            </div>

            <div className="downloadCenterFileList">
              {visibleFiles.map((file) => (
                <div
                  className={`downloadCenterFileRow ${selectedFileNames[file.fileName] ? 'selected' : ''}`}
                  key={file.fileName}
                >
                  <label className="downloadCenterCheckbox">
                    <input
                      checked={!!selectedFileNames[file.fileName]}
                      disabled={isDownloading}
                      onChange={() => handleFileSelect(file.fileName)}
                      type="checkbox"
                    />
                    <span className="downloadCenterCheckboxLabel">Select {file.displayName}</span>
                  </label>
                  <div className="downloadCenterFileInfo">
                    <div className="downloadCenterFileName">{file.displayName}</div>
                    <div className="downloadCenterFileMeta">
                      {file.customer} / {file.folder}
                    </div>
                  </div>
                  <div className="downloadCenterFileMeta">
                    Modified {formatDownloadCenterDate(file.lastModified)}
                  </div>
                  <div className="downloadCenterFileMeta">
                    {formatDownloadCenterFileSize(file.contentLength)}
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>
    </ReportPageShell>
  )
}

export default DownloadCenter
